import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteItineraryComponent } from '../route-itinerary/route-itinerary.component';
import { VMEComponentsModule } from '../../../vme-components.module';

@Component({
  selector: 'route-recommendation-detailed-view',
  standalone: true,
  imports: [CommonModule, RouteItineraryComponent, VMEComponentsModule],
  templateUrl: './route-recommendation-detailed-view.component.html',
  styleUrls: ['./route-recommendation-detailed-view.component.scss'],
})
export class RouteRecommendationDetailedViewComponent {
  @Input() routeRecommendationId: number;

  selectedTaskId: number;

  itineraryLoading: boolean = true;
  mapLoading: boolean = true;

  constructor() {}

  public get showLoadingOverlay(): boolean {
    return this.itineraryLoading || this.mapLoading;
  }
}
